<script>
import '@/components/pickerjs/css/picker.min.css'
import Picker from '@/components/pickerjs'
import DOMUtils from '@/utils/DOMUtils'

export default
{
    name: 'time-picker',

    props:
    {
        format: { type: String, default: 'YYYY-MM-DD HH:mm:ss.SSS' },

        // bound to v-model
        value: { default: '' },
        show: { default: true },

        placeholder: { type: String, default: 'Cliquer pour choisir une date' },
        useText: { type: Boolean, default: false },
        default: { type: Object, default: () => ({}) }
    },

    created ()
    {
        this.fieldValue = this.value
    },

    render () 
    {
        return (
            <input v-show={this.show} type='text' placeholder={this.placeholder} class='time-picker' on-change={this.onChange} value={this.fieldValue}>
            </input>
        )
    },

    mounted ()
    {
        this.bindToInput(this.$el)
    },

    data () 
    {
        return {
            el: null,
            fieldValue: '',
            picker: null,
        }
    },

    computed:
    {
    },
    
    watch:
    {
        value ()
        {
            this.fieldValue = this.value
        },

        fieldValue (now, before)
        {
            if (now == before) return
            if (this.picker && this.fieldValue)
            {
                if (this.useText)
                {
                    this.picker.element.value = this.fieldValue
                }
                else this.picker.setDate(new Date(this.fieldValue))
            }
        }
    },

    methods:
    {
        bindToInput (el)
        {
            this.el = el

            const text =
            {
                title: DOMUtils.nbsp,
                cancel: 'Annuler',
                confirm: 'OK',
                year: 'Année',
                month: 'Mois',
                day: 'Jour',
                hour: 'Heure',
                minute: 'Minute',
                second: 'Seconde',
                millisecond: 'Milliseconde',
            }

            const date = new Date(this.fieldValue || new Date())
            if (this.default.year) date.setFullYear(this.default.year)
            const options = {language: 'fr', text, format: this.format, headers: true , date}
            if (this.useText) delete options.date

            this.picker = new Picker(el, options)
            el.type = 'text'
        },

        pick ()
        {
            this.picker.element.click()
        },

        onChange ()
        {
            const val = this.useText ? this.el.value : this.picker.date
            this.$emit('input', val)
            this.$emit('change', val)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.time-picker
{
    width: -webkit-fill-available;
    padding: 10px;
    appearance: inherit;
    border: 2px solid var(--theme-border-color);
    border-radius: 4px;
    text-align: center;
    background-color: var(--theme-content-background-color);
    color: var(--theme-text-color);
}

.picker-fixed
{
    pointer-events: none;
}

.picker-dialog
{
    border-radius: 20px 20px 0 0;
    background-color: var(--theme-background-color);
    border-color: var(--theme-border-color-strong);
    pointer-events: all;

    .OnDesktop({
        width: 40vw;
        margin-left: 30vw;
    });

    .picker-picked, .picker-confirm
    {
        color: var(--theme-accent-color-text);
    }

    .picker-header
    {
        display: flex;
        flex-direction: row;
        align-items: center;
        border-color: inherit;
        border-radius: inherit;
        background-color: var(--theme-border-color);

        .leave-empty-action
        {
            cursor: pointer;
            color: var(--theme-text-color);

            &:hover
            {
                color: var(--theme-accent-color-text);
            }
        }

        .picker-close
        {
            right: 5px;
        }
    }

    .picker-body
    {
        border-color: inherit;

        .picker-grid
        {
            border-color: inherit;

            .picker-cell
            {
                border-color: inherit;

                .picker-cell__body
                {
                    &::before
                    {
                        background-image: linear-gradient(0deg,hsla(0,0%,100%,0),var(--theme-background-text-color));
                    }

                    &::after
                    {
                        background-image: linear-gradient(0deg,var(--theme-background-text-color), hsla(0,0%,100%,0));
                    }
                }
            }
        }
    }

    .picker-footer
    {
        border-color: inherit;
        background-color: var(--theme-border-color);

        .picker-cancel
        {
            color: var(--theme-text-color);
        }

        .picker-confirm, .picker-cancel
        {
            &:hover
            {
                background-color: var(--theme-border-color-strong);
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/TimePicker.vue